import ImageUpload from "components/image-upload/image-upload";
import { useTranslation } from "react-i18next";
import { FiCamera } from "react-icons/fi";
import {useEffect, useRef, useState} from "react";
import {CoverDefaultPlaceholder,ProfileDefaultPlaceholder, } from "constants/images";
import { maxUploadSize } from "utils/constant";
import CropThumbnailModal from "components/profile/milestones/crop-thumbnail";
import { useDialogHook } from "utils/customhooks";
import toast from "react-hot-toast";
import CropCoverModal from "components/profile/milestones/crop-cover";
import EditCoverPhoto from "components/settings/component/EditCoverPhoto";

const ImageSection = ({userData = {},setState =()=>{},state={}})=>{

    const {t} = useTranslation();
    const fileInputRef = useRef(null);
    const [profile, setProfile] = useState(ProfileDefaultPlaceholder);
    const [uploadErrors, setUploadErrors] = useState(null);
    const [cover, setCover] = useState(CoverDefaultPlaceholder);

    const cropProfile = useDialogHook(CropThumbnailModal);
    const cropCover = useDialogHook(CropCoverModal);
    const editCover = useDialogHook(EditCoverPhoto); 
    
    const updateCoverPhoto = async (cropFile=null, selectedCover=null)=>{
        try {
          
            console.log(cropFile);
            console.log(selectedCover);
            let addNewCover = [];
            let url = null;
            if(cropFile){
                url = URL.createObjectURL(cropFile);
                addNewCover = [...state.preview_covers, {media_id:null, url:url }]
            }else{
                addNewCover = [...state.preview_covers]
            }
            setState((prev) => ({
              ...prev,
              cover_image_album: selectedCover ? selectedCover?.url : null,
              cover_image_file: null,
              validationErrors: null,
              preview_covers:addNewCover,
              media_id: selectedCover?.id || null,
              // this line will prevent clearing profile picture IF profile was changed and not saved yet
              ...(!(!!profile && !!state.profile_image_file) && {
                profile_image_file: null,
              })
            }));
            return true;
        } catch (error) {
          if (error.status === 422) {
            toast.error(t('somethingWentWrong'));
            return setState((prev) => ({
              ...prev,
              validationErrors: error.data?.errors,
            }));
          }
    
          toast.error(
            error.status === 401
              ? "Invalid Credentials"
              : error?.data?.message || t('somethingWentWrong')
          );
          console.log(error)
        }
    }

    useEffect(()=>{
       if(state.cover_image_file || state.cover_image_album){
            let urlCover = state.cover_image_album || URL.createObjectURL(state.cover_image_file)
            setCover(urlCover)
       }if(state.profile_image_file){
            let urlProfile = URL.createObjectURL(state.profile_image_file)
            setProfile(urlProfile)
       }
    },
    [state])
    
    const onUploadImage = async (e, type = "profile", ) => {
     const file = type === "cover" ? e[0] : e.target.files[0];
     const reader = new FileReader();
 
     reader.addEventListener(
       "load",
       function () {
         if (file.size > maxUploadSize) {
           setUploadErrors({
             ...uploadErrors,
             [type]: "The file is too large. Maximum size is 50MB.",
           });
           return;
         }
 
         // convert image file to base64 string
         const image = reader.result?.toString() || "";
         let title =
           type === "profile" ? "Crop Profile Picture" : "Crop Cover Photo";
         const Iprops = {
           image: image,
           type: file.type,
           returnType: "file",
           title: title
         };
         if (image) {
           if (type === "profile") {
             cropProfile(Iprops, (result) => {
               if (result) {
                 const { imageFile, preview } = result;
                 setState((prev) => ({
                   ...prev,
                   profile_image_file: imageFile,
                 }));
                 setProfile(preview);
               }
             });
             fileInputRef.current.value = null;
           } else {
             Iprops.updateCoverPhoto = updateCoverPhoto;
             cropCover(Iprops, (result) => {
               if (result) {
                 const { imageFile, preview } = result;
                 setState((prev) => ({ ...prev, cover_image_file: imageFile,
                   //  list_covers:[...prev.list_covers,imageFile],
                   //  preview_covers:[...prev.preview_covers,preview]
                    }));
                 setCover(preview);
                 // editCoverHandler([preview]);
               }
             });
           }
         }
       },
       false
     );
     
     if (file) { 
       if (file.size > maxUploadSize) {
         setUploadErrors({
           ...uploadErrors,
           [type]: "The file is too large. Maximum size is 50MB.",
         });
       } else {
         setUploadErrors(null);
         reader.readAsDataURL(file);
       }
     }
    };  
    
    const editCoverHandler = (newUpload=[])=>{
        let preview_covers = newUpload.length > 0 ? [...state.preview_covers,...newUpload] : state.preview_covers;
        editCover(
        {
            userData,
            profile,
            onUploadImage:(e)=>{onUploadImage(e, "cover")},
            preview_covers:preview_covers,
            cover,
            setCover:(preview)=>{
                setCover(preview.webp_url || preview.url);
                setState(prev=>{
                    return {...prev, status:preview.status, media_id:preview.media_id}}
                );
            },
            updateCoverPhoto
        },
        (callback) => {
            if (callback) {
            // getPhotoVideos();
            }
        }
        );
    }
  
    return(
    <div className="px-2">
        <div>
            <h1 className="font-bold text-base 2sm:text-lg ">Upload some images</h1>
            <p className="text-xs 2sm:text-base">Start adding your profile and cover images</p>
        </div>
        <div className="mt-2">
            <ImageUpload
                ref={fileInputRef}
                label={t('profilePicture')}
                image={profile}
                accept="image/*"
                icon={<FiCamera className="text-white text-lg" />}
                id="profile-photo"
                onChange={(e) => onUploadImage(e, "profile")}
                error={uploadErrors ? uploadErrors["profile"] : null}
            />
            <ImageUpload
                label={t('coverPhoto')}
                accept="image/*"
                image={cover}
                icon={<FiCamera className="text-white text-lg mr-2" />}
                className="absolute px-4 text-xs text-white font-semibold right-2 top-2 h-9 bg-black bg-opacity-50 rounded-md flex items-center justify-center"
                innerLabel={cover ? "Edit Photo" : "Edit Photo"}
                wrapperClass="relative w-full max-h-50 bg-thBg rounded-md"
                id="cover-photo"
                isButton={true}
                onClick={editCoverHandler}
                onChange={(e) => onUploadImage(e, "cover")}
                error={uploadErrors ? uploadErrors["cover"] : null}
            />
        </div>
    </div>
    )
}

export default ImageSection;